import {IsoDate} from "../../../../../pseudo-types/DateTypes";

export type DashboardFeatures = "strategyBuilder" | "portfolio" | "charting" | "backtesting";

export enum FeatureStatus {
    NOT_TRIALED = "NOT_TRIALED",
    INACTIVE = "INACTIVE",
    ACTIVE = "ACTIVE",
    TRIALING = "TRIALING",
    CANCELLED = "CANCELLED"
}

export interface DashboardFeatureState {
    readonly visible: boolean;
    readonly trialing: boolean;
    readonly trialEnds: IsoDate | null;
    readonly status: FeatureStatus;
    readonly storeUrl: string | null;
    readonly trialPeriod: number;
}

export type DashboardFeatureStates = {
    readonly [K in DashboardFeatures]: DashboardFeatureState;
};

export interface DashboardFeaturesModel extends DashboardFeatureStates {
    readonly hasBillingDetails: boolean;
}
